import { render } from "./EditDiscussionProfile.vue?vue&type=template&id=55a09690"
import script from "./EditDiscussionProfile.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./EditDiscussionProfile.vue?vue&type=script&charset=utf-8&lang=js"

import "./EditDiscussionProfile.vue?vue&type=style&index=0&id=55a09690&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__